document.addEventListener("DOMContentLoaded", function () {
	let registers = document.querySelectorAll('.register_btn');
	const loading = document.querySelector('.loading');
	if (registers.length > 0) {
		registers.forEach(register => {
			register.addEventListener("click", function (event) {
				loading.style.display = 'block';

				// grecaptcha.ready(function () {
				// 	grecaptcha
				// 		.execute(google_apps["recaptcha_site_key"], {
				// 			action: "submit",
				// 		})
				// 		.then(function (token) {
				// 			if (token) {
				const form_object = {
					OfferKey: register.getAttribute('data-key'),
					memberId: register.getAttribute('data-memberid')
					// recaptchaToken: token
				};

				fetch("/wp-json/LMS/v1/OfferRegistration/", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(form_object),
				})
					.then((response) => {
						if (!response.ok) {
							loading.style.display = 'none';
							register.closest('.d-flex').querySelector('.failure-message').classList.remove('d-none');
							console.log("error")
							// throw new Error("Network response was not ok: " + response.statusText);
						}
						return response.json();
					})
					.then((result) => {
						loading.style.display = 'none';
						register.classList.add('disabled');
						if (result.success)
							register.closest('.d-flex').querySelector('.success-message').classList.remove('d-none');
						else
							register.closest('.d-flex').querySelector('.failure-message').classList.remove('d-none');
						console.log("success:", result);
					})
					.catch((err) => {
						console.error("Fetch error:", err);
						register.closest('.d-flex').querySelector('.failure-message').classList.remove('d-none');
					});
				// } else {
				// 	document.querySelector('.failure-message').classList.remove('d-none');
				// }

				// });
				// });

			});
		});
	}
});

